import { render, staticRenderFns } from "./schoolAccessAudit.vue?vue&type=template&id=eda535d6&scoped=true&"
import script from "./schoolAccessAudit.vue?vue&type=script&lang=js&"
export * from "./schoolAccessAudit.vue?vue&type=script&lang=js&"
import style0 from "./schoolAccessAudit.vue?vue&type=style&index=0&id=eda535d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda535d6",
  null
  
)

export default component.exports